import { render, staticRenderFns } from "./ImportPersonalAccount.vue?vue&type=template&id=18c8b1f6&scoped=true&"
import script from "./ImportPersonalAccount.vue?vue&type=script&lang=ts&"
export * from "./ImportPersonalAccount.vue?vue&type=script&lang=ts&"
import style0 from "./ImportPersonalAccount.vue?vue&type=style&index=0&id=18c8b1f6&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18c8b1f6",
  null
  
)

export default component.exports